import styled from 'styled-components';
import { FlexContainer } from '@taxdown/piccolo-web';
import { Lottie } from 'Components/UI';
import { MOBILE_WIDTH } from 'Styles/variables/sizes';

export const StyledLottie = styled(Lottie)`
  width: 100%;
  max-width: 300px;
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    max-width: 200px;
  }
`;

export const Container = styled(FlexContainer)`
  padding-top: ${({ theme: { reference } }) => reference.dimension_16};
`;
